import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./Spinner.css";
import "./hm-theme.css";

const AddLabCoordinators = ({ isOpen, onRequestClose, labId, coOrdinator }) => {
  const navigate = useNavigate();
  const [coordinator, setCoordinator] = useState({
    coOrdinatorEmail: "",
    coOrdinatorName: "",
    coOrdinatorMobileno: "",
    labId: labId || "",
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (coOrdinator) {
      setCoordinator({
        coOrdinatorEmail: coOrdinator.coOrdinatorEmail,
        coOrdinatorMobileno: coOrdinator.coOrdinatorMobileno,
        coOrdinatorName: coOrdinator.coOrdinatorName,
        labId: labId,
      });
    } else {
      setCoordinator({
        coOrdinatorEmail: "",
        coOrdinatorMobileno: "",
        coOrdinatorName: "",
        labId: labId,
      });
    }
  }, [coOrdinator, labId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;

    try {
      const requestBody = { ...coordinator };
      if (coOrdinator) {
        requestBody.id = coOrdinator.id;
        await axios.post(`/api/lab-coordinators/update`, requestBody, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success("Lab Co-ordinator updated successfully.");
      } else {
        await axios.post(`/api/lab-coordinators/create`, requestBody, {
          headers: { Authorization: `Bearer ${token}` },
        });
        toast.success("Lab Co-ordinator created successfully.");
      }
      onRequestClose();
      setCoordinator({
        coOrdinatorEmail: "",
        coOrdinatorName: "",
        coOrdinatorMobileno: "",
        labId: labId,
      });
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  function rhandle(e) {
    const { id, value } = e.target;
    setCoordinator((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  }

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">badge</i>
          {coOrdinator ? "Update Co-ordinator" : "Add Co-ordinator"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="coOrdinatorName" className="form-label small fw-semibold">
              Co-ordinator Name <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="coOrdinatorName"
              type="text"
              placeholder="Full Name"
              value={coordinator.coOrdinatorName}
              onChange={rhandle}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="coOrdinatorEmail" className="form-label small fw-semibold">
              Co-ordinator Email <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="coOrdinatorEmail"
              type="email"
              placeholder="coordinator@example.com"
              value={coordinator.coOrdinatorEmail}
              onChange={rhandle}
              required
            />
          </div>

          <div className="mb-4">
            <label htmlFor="coOrdinatorMobileno" className="form-label small fw-semibold">
              Mobile Number <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="coOrdinatorMobileno"
              type="text"
              placeholder="+91 XXXXXXXXXX"
              value={coordinator.coOrdinatorMobileno}
              onChange={rhandle}
              required
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>{coOrdinator ? "edit" : "save"}</i>
              {coOrdinator ? "Update Co-ordinator" : "Save Co-ordinator"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddLabCoordinators;
